import { Stack } from 'expo-router';
import React from 'react';

import BankOpsPage from '../../bank-ops/components/BankOpsPage';

export default function BankOpsIndexPage() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Fruitful Bank Operations',
                }}
            />
            <BankOpsPage />
        </>
    );
}
